import React from 'react';
import { Link } from 'react-router-dom';
import IconButton from '../IconButton/IconButton';
import TextIcon, { Icon } from '../Icon/TextIcon';
import styles from './OnboardingChecklist.module.scss';

export interface OnboardingChecklistItem {
  key: string;
  label: string;
  complete: boolean;
  instructions: string;
  linkTo: string;
  linkLabel: string;
}

export interface OnboardingChecklistProps {
  items: OnboardingChecklistItem[];
  open: boolean;
  onToggleOpen: () => void;
  onDismiss: () => void;
}

const OnboardingChecklist = ({ items, open, onToggleOpen, onDismiss }: OnboardingChecklistProps) => {
  const [expandedKey, setExpandedKey] = React.useState<string | null>(null);
  const completeCount = items.filter((item) => item.complete).length;

  return (
    <>
      <button type='button' className={styles.tab} onClick={onToggleOpen} aria-expanded={open}>
        <TextIcon icon={open ? Icon.AngleRight : Icon.AngleLeft} additionalStyles={styles.tabIcon} />
        <span className={styles.tabLabel}>
          Getting Started ({completeCount}/{items.length})
        </span>
      </button>

      <div className={`${styles.drawer} ${open ? styles.drawerOpen : ''}`}>
        <div className={styles.drawerHeader}>
          <span className={styles.drawerTitle}>Let&rsquo;s get your account set up</span>
          <IconButton onClick={onToggleOpen}>
            <TextIcon icon={Icon.Close} />
          </IconButton>
        </div>

        <ul className={styles.list}>
          {items.map((item) => {
            const isExpanded = expandedKey === item.key;
            return (
              <li key={item.key} className={styles.item}>
                <button
                  type='button'
                  className={styles.itemHeader}
                  onClick={() => setExpandedKey(isExpanded ? null : item.key)}
                  aria-expanded={isExpanded}
                >
                  {item.complete ? (
                    <TextIcon icon={Icon.CheckmarkCircle} additionalStyles={styles.iconComplete} />
                  ) : (
                    <span className={styles.iconIncomplete} />
                  )}
                  <span className={item.complete ? styles.labelComplete : styles.label}>{item.label}</span>
                  <TextIcon
                    icon={isExpanded ? Icon.AngleUp : Icon.AngleDown}
                    additionalStyles={styles.expandIcon}
                  />
                </button>
                {isExpanded && (
                  <div className={styles.itemBody}>
                    <p className={styles.instructions}>{item.instructions}</p>
                    <Link to={item.linkTo} className={styles.itemLink}>
                      {item.linkLabel}
                    </Link>
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        <button type='button' className={styles.dismissLink} onClick={onDismiss}>
          Don&rsquo;t show this again
        </button>
      </div>
    </>
  );
};

export default OnboardingChecklist;
